const paths = {
  avatar: {
    id: "avatar-icon",
    path:
      "M10.5,12c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S7.2,12,10.5,12z M14.7,13.5h-0.8c-1,0.5-2.2,0.8-3.4,0.8S8.1,14,7.1,13.5 H6.3c-3.5,0-6.3,2.8-6.3,6.3v2C0,23,1,24,2.2,24h16.5c1.2,0,2.2-1,2.2-2.2v-2C21,16.3,18.2,13.5,14.7,13.5z",
  },

  add: {
    id: "add-icon",
    path:
      "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
  },

  aperature: {
    id: "aperature-icon",
    path:
      "M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M3.3,18.7c2,2.6,5.2,4.3,8.8,4.3 L6.5,13L3.3,18.7z M10.2,17.5l3.1,5.4c3.5-0.4,6.5-2.5,8.2-5.4H10.2z M2,7.6C1.4,8.9,1.1,10.4,1.1,12c0,2.1,0.6,4,1.6,5.7L8.4,7.6H2 z M15.7,16.4H22c0.6-1.4,0.9-2.8,0.9-4.4c0-2.1-0.6-4-1.6-5.6L15.7,16.4z M9.6,16.4h4.8l2.5-4.4l-2.5-4.5H9.6L7.1,12L9.6,16.4z M11.9,1.1l5.6,9.9l3.2-5.6C18.7,2.7,15.5,1,11.9,1.1z M2.5,6.5h11.3l-3.1-5.4C7.2,1.5,4.2,3.6,2.5,6.5z",
  },

  arrowRight: {
    id: "arrow-right-icon",
    path: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
  },

  arrowLeft: {
    id: "arrow-left-icon",
    path: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
  },

  burger: {
    id: "burger-icon",
    path:
      "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z",
  },

  book: {
    id: "book-icon",
    path:
      "M23.4,7.8l-1.2-0.3v1.1l-8.9,10.4c-0.1,0.1-0.2,0.2-0.3,0.3c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.1c0,0,0,0,0,0 c-0.1,0-0.2,0-0.3,0l-9.1-2.6c-1-0.3-1.7-1.3-1.4-2.4c0-0.2,0.1-0.3,0.2-0.5c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3 c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0,0,0.1,0c0.1-0.1,0.3-0.2,0.5-0.2c0,0,0,0,0,0l0,0c0.4-0.1,0.8-0.1,1.2,0 l7.7,2.1c0.5,0.1,1,0,1.4-0.4l5.4-6.2l3.7-4.2c0.4-0.5,0.2-1.2-0.4-1.3l-9.6-2.7c-0.6-0.2-1.3,0-1.7,0.5L0.9,12.3l0,0 c-0.8,0.8-1.2,2-0.9,3.2c0.3,1.4,1.5,2.4,2.8,2.8l8.8,2.5c0.2,0.1,0.5,0.1,0.7,0.1c0.8,0,1.6-0.3,2.1-1l9.3-10.9 C24.2,8.7,24,8,23.4,7.8z",
  },

  box: {
    id: "box-icon",
    path:
      "M11.4,24c-0.1,0-0.3,0-0.4-0.1L0.6,19.7C0.2,19.5,0,19.2,0,18.8V5.2c0-0.4,0.2-0.8,0.6-0.9L11,0.1C11.1,0,11.2,0,11.4,0 c0.1,0,0.3,0,0.4,0.1l10.4,4.3c0.4,0.2,0.6,0.5,0.6,0.9v13.5c0,0.4-0.2,0.8-0.6,0.9c-10.3,4.2-10.4,4.3-10.5,4.3h0 C11.6,24,11.5,24,11.4,24z M12.3,21.6l8.4-3.5V6.8l-8.4,3.5V21.6z M10.4,21.6V10.2L6.7,8.7v2.9c0,0.5-0.4,1-1,1s-1-0.4-1-1V7.9 L1.9,6.8v11.3L10.4,21.6z M11.4,8.5l7.9-3.2l-3.4-1.4L8.2,7.2L11.4,8.5z M5.6,6.2l7.6-3.3L11.4,2L3.5,5.3L5.6,6.2z",
  },

  chevronUp: {
    id: "chevron-up-icon",
    path: "M21.2,19.4L12,10.2l-9.2,9.2L0,16.6l12-12l12,12L21.2,19.4z",
  },

  chevronRight: {
    id: "chevron-right-icon",
    path: "M4.6,21.2l9.2-9.2L4.6,2.8L7.4,0l12,12l-12,12L4.6,21.2z",
  },

  chevronDown: {
    id: "chevron-down-icon",
    path: "M24,7.4l-12,12L0,7.4l2.8-2.8l9.2,9.2l9.2-9.2L24,7.4z",
  },

  chevronLeft: {
    id: "chevron-left-icon",
    path: "M16.6,24l-12-12l12-12l2.8,2.8L10.2,12l9.2,9.2L16.6,24z",
  },

  checkmark: {
    id: "checkmark-icon",
    path: "M9.4,20.6L24 6 21.4 3.4 9.4 15.4 2.6 8.6 0 11.1z",
  },

  degrees: {
    id: "degrees-icon",
    path:
      "M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0c6.6,0,12,5.4,12,12C24,18.6,18.6,24,12,24z M12,22.9c1.7,0,3.2-2.3,4-5.6 c-1.3,0.2-2.6,0.3-4,0.3c-1.4,0-2.8-0.1-4-0.3C8.8,20.6,10.3,22.9,12,22.9z M17.2,17.1c-0.5,2.4-1.4,4.3-2.5,5.5 c3.9-1,6.9-4.1,7.9-7.9C21.4,15.7,19.5,16.6,17.2,17.1z M1.4,14.7c1,3.9,4,7,7.9,7.9c-1.1-1.2-2-3.1-2.5-5.5 C4.5,16.6,2.6,15.7,1.4,14.7z M7.7,16.2c1.3,0.2,2.8,0.4,4.3,0.4c1.5,0,3-0.1,4.3-0.4c0.2-1.3,0.4-2.7,0.4-4.2s-0.1-2.9-0.4-4.2 C15,7.6,13.5,7.4,12,7.4c-1.5,0-3,0.1-4.3,0.4C7.5,9.1,7.4,10.5,7.4,12S7.5,14.9,7.7,16.2z M17.4,8c0.2,1.2,0.3,2.6,0.3,4 c0,1.4-0.1,2.7-0.3,4c3.3-0.8,5.6-2.3,5.6-4C22.9,10.3,20.7,8.8,17.4,8z M1.1,12c0,1.7,2.3,3.2,5.6,4c-0.2-1.2-0.3-2.6-0.3-4 c0-1.4,0.1-2.7,0.3-4C3.3,8.8,1.1,10.3,1.1,12z M17.2,6.9c2.3,0.5,4.2,1.4,5.4,2.4c-1-3.9-4-7-7.9-7.9C15.8,2.6,16.7,4.5,17.2,6.9z M9.3,1.4c-3.9,1-6.9,4.1-7.9,7.9c1.2-1.1,3.1-1.9,5.4-2.4C7.3,4.5,8.2,2.6,9.3,1.4z M12,6.4c1.4,0,2.8,0.1,4,0.3 c-0.8-3.3-2.3-5.6-4-5.6S8.8,3.4,8,6.7C9.2,6.5,10.6,6.4,12,6.4z",
  },

  drone: {
    id: "drone-icon",
    path:
      "M 3 4 A 1.0001 1.0001 0 1 0 3 6 L 5 6 L 5 8 L 4 8 A 1.0001 1.0001 0 1 0 4 10 L 9 10 L 9 12 L 8.1113281 12 C 5.8602358 12 4 13.823314 4 16.064453 L 4 19 A 1.0001 1.0001 0 1 0 6 19 L 6 16.064453 C 6 14.919593 6.9244204 14 8.1113281 14 L 15.888672 14 C 17.07558 14 18 14.919593 18 16.064453 L 18 19 A 1.0001 1.0001 0 1 0 20 19 L 20 16.064453 C 20 13.823314 18.139764 12 15.888672 12 L 15 12 L 15 10 L 17.832031 10 A 1.0001 1.0001 0 0 0 18.158203 10 L 20 10 A 1.0001 1.0001 0 1 0 20 8 L 19 8 L 19 6 L 21 6 A 1.0001 1.0001 0 1 0 21 4 L 15 4 A 1.0001 1.0001 0 1 0 15 6 L 17 6 L 17 8 L 7 8 L 7 6 L 9 6 A 1.0001 1.0001 0 1 0 9 4 L 3 4 z",
  },

  email: {
    id: "email-icon",
    path:
      "M21.2,3.3H2.8C1.2,3.3,0,4.6,0,6.1v11.8c0,1.5,1.2,2.8,2.8,2.8h18.5c1.5,0,2.8-1.2,2.8-2.8V6.1C24,4.6,22.8,3.3,21.2,3.3z M21.5,5.8L21.5,5.8l-9.2,6.6c-0.2,0.1-0.5,0.1-0.7,0L2.5,5.9v0H21.5z M2.5,17.5V8.9l8.2,5.9c0.4,0.3,0.9,0.4,1.3,0.4 c0.5,0,0.9-0.1,1.4-0.4l8.2-5.9v8.6c0,0.3-0.3,0.6-0.6,0.6H3.1C2.8,18.2,2.5,17.9,2.5,17.5z",
  },

  emailAt: {
    id: "email-at-icon",
    path:
      "M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z",
  },

  emailSend: {
    id: "email-send-icon",
    path:
      "M23.2,0.1l-22.9,10c-0.4,0.2-0.4,0.8,0,1l6.2,3.5c0.4,0.2,0.8,0.2,1.1-0.1L19.9,3.9c0.1-0.1,0.3-0.2,0.4-0.1c0.1,0.1,0,0.3-0.1,0.4L9.6,16c-0.3,0.3-0.3,0.8-0.1,1.2l4.1,6.5c0.2,0.4,0.8,0.4,1,0l9.5-22.9C24.2,0.3,23.7-0.2,23.2,0.1z",
  },

  externalLink: {
    id: "external-link-id",
    path:
      "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6 M15 3h6v6 M10 14L21 3",
  },

  facebook: {
    id: "facebook-icon",
    path:
      "M21,0H3C1.3,0,0,1.3,0,3v18c0,1.7,1.3,3,3,3h9v-8.2H9V12h3V9c0-2.5,2-4.5,4.5-4.5h3v3.8H18c-0.8,0-1.5-0.1-1.5,0.8v3h3.8 l-1.5,3.8h-2.2V24H21c1.7,0,3-1.3,3-3V3C24,1.3,22.7,0,21,0z",
  },

  gallery: {
    id: "gallery-icon",
    path:
      "M23,2.5H1c-0.5,0-1,0.4-1,1v17c0,0.5,0.4,1,1,1h22c0.5,0,1-0.4,1-1v-17C24,3,23.6,2.5,23,2.5z M22,14.3l-4-3.2 c-0.4-0.3-0.9-0.3-1.3,0L12.3,15l-6-6.7C6.1,8.1,5.8,8,5.6,8C5.3,8,5,8.1,4.8,8.3L2,11.4V4.5H22V14.3z M12,5.1c-1.8,0-3.2,1.5-3.2,3.2s1.4,3.2,3.2,3.2s3.2-1.5,3.2-3.2C15.2,6.5,13.8,5.1,12,5.1z",
  },

  home: {
    id: "home-icon",
    path:
      "M2.3,23.3V9.7c0-0.3,0.1-0.5,0.3-0.7l8.6-8.6C11.4,0.1,11.7,0,12,0c0.3,0,0.6,0.1,0.8,0.3L21.4,9c0.2,0.2,0.3,0.5,0.3,0.7 v13.6c0,0.4-0.3,0.7-0.7,0.7H2.9C2.6,24,2.3,23.7,2.3,23.3z M19.3,21.5V10.3L12,3.1l-7.3,7.2v11.2h3.7v-6.7c0-0.4,0.3-0.7,0.7-0.7 h5.8c0.4,0,0.7,0.3,0.7,0.7v6.7H19.3z M13.3,21.5v-5.1h-2.6v5.1H13.3z",
  },

  info: {
    id: "info-icon",
    path:
      "M12,24C5.4,24,0,18.6,0,12C0,5.4,5.4,0,12,0s12,5.4,12,12C24,18.6,18.6,24,12,24z M12,2.5c-5.2,0-9.5,4.3-9.5,9.5 c0,5.2,4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5C21.5,6.8,17.2,2.5,12,2.5z M11.2,19c-0.3,0-0.5-0.2-0.5-0.5V10c0-0.3,0.2-0.5,0.5-0.5h1.5c0.3,0,0.5,0.2,0.5,0.5v8.5c0,0.3-0.2,0.5-0.5,0.5H11.2z M12,8.3c-0.9,0-1.6-0.7-1.6-1.6S11.1,5,12,5c0.9,0,1.6,0.7,1.6,1.6S12.9,8.3,12,8.3z",
  },

  link: {
    id: "link-icon",
    path:
      "M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z",
  },

  linkedIn: {
    id: "linkedin-icon",
    path:
      "M 0,7.5 H 5.4000001 V 24 H 0 Z M20,7.7c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.6-0.1-1-0.1c-3.1,0-5.1,2.3-5.8,3.2V7.5H7.5V24h5.4v-9 c0,0,4.1-5.6,5.8-1.5c0,3.7,0,10.5,0,10.5H24V12.9C24,10.4,22.3,8.3,20,7.7z M 5.1999998,2.5999999 A 2.5999999,2.5999999 0 0 1 2.5999999,5.1999998 2.5999999,2.5999999 0 0 1 0,2.5999999 2.5999999,2.5999999 0 0 1 2.5999999,0 2.5999999,2.5999999 0 0 1 5.1999998,2.5999999 Z",
  },

  location: {
    id: "location-icon",
    path:
      "M12,0C8.1,0,4.9,3.2,4.9,7.1c0,4.9,6.4,12,6.6,12.3c0.3,0.3,0.7,0.3,1,0c0.3-0.3,6.6-7.5,6.6-12.3C19.1,3.2,15.9,0,12,0z M12,10.7c-2,0-3.6-1.6-3.6-3.6S10,3.5,12,3.5s3.6,1.6,3.6,3.6S14,10.7,12,10.7z M16.8,17.9c-0.3-0.1-0.7-0.3-1.1-0.4c-0.3,0.4-0.6,0.9-0.9,1.2c1.8,0.4,2.9,1.2,2.9,1.7c0,0.8-2.2,2.1-5.7,2.1 c-3.5,0-5.7-1.2-5.7-2.1c0-0.6,1.1-1.3,2.9-1.7c-0.3-0.4-0.6-0.8-0.9-1.2c-0.4,0.1-0.7,0.2-1.1,0.4c-1.5,0.6-2.3,1.6-2.3,2.6 s0.8,2,2.3,2.6c1.3,0.6,3,0.9,4.8,0.9s3.5-0.3,4.8-0.9c1.5-0.6,2.3-1.6,2.3-2.6S18.3,18.6,16.8,17.9z",
  },

  modelling: {
    id: "modelling-icon",
    path:
      "M24,12c0-6.6-5.4-12-12-12C5.4,0,0,5.4,0,12s5.4,12,12,12c5,0,9.3-3,11.1-7.4h0l0.4-1h0C23.8,14.5,24,13.2,24,12z M22.9,12 c0,1.1-0.2,2.2-0.5,3.2l-4.7-1.7V8.8L12.5,6V1.1C18.3,1.4,22.9,6.1,22.9,12z M12,6.8l4.2,2.3L12,11.4L7.8,9.1L12,6.8z M7.2,10 l4.2,2.4V17l-4.2-2.3V10z M12.5,12.4l4.2-2.4v4.6L12.5,17C12.5,17,12.5,12.4,12.5,12.4z M11.5,1.1V6L6.3,8.8v4.8l-4.7,1.7 c-0.3-1.1-0.5-2.2-0.5-3.4C1.1,6.1,5.7,1.4,11.5,1.1z M12,22.9c-4.5,0-8.3-2.7-10-6.6l4.3-1.6v0.4l5.7,3.2l5.7-3.2v-0.6l4.4,1.6 C20.4,20.2,16.5,22.9,12,22.9z",
  },

  minus: {
    id: "minus-icon",
    path:
      "M24,12c0-6.6-5.4-12-12-12C5.4,0,0,5.4,0,12s5.4,12,12,12c5,0,9.3-3,11.1-7.4h0l0.4-1h0C23.8,14.5,24,13.2,24,12z M22.9,12 c0,1.1-0.2,2.2-0.5,3.2l-4.7-1.7V8.8L12.5,6V1.1C18.3,1.4,22.9,6.1,22.9,12z M12,6.8l4.2,2.3L12,11.4L7.8,9.1L12,6.8z M7.2,10 l4.2,2.4V17l-4.2-2.3V10z M12.5,12.4l4.2-2.4v4.6L12.5,17C12.5,17,12.5,12.4,12.5,12.4z M11.5,1.1V6L6.3,8.8v4.8l-4.7,1.7 c-0.3-1.1-0.5-2.2-0.5-3.4C1.1,6.1,5.7,1.4,11.5,1.1z M12,22.9c-4.5,0-8.3-2.7-10-6.6l4.3-1.6v0.4l5.7,3.2l5.7-3.2v-0.6l4.4,1.6 C20.4,20.2,16.5,22.9,12,22.9z",
  },

  moon: {
    id: "moon-icon",
    path:
      "M23.6,14c-0.2-0.2-0.7-0.3-1-0.2c-0.9,0.2-1.8,0.3-2.7,0.3c-5.5,0-10-4.4-10-9.9c0-0.9,0.1-1.8,0.3-2.6c0.1-0.3,0-0.8-0.3-1.1S9.3-0.1,8.9,0C3.7,1.6,0,6.4,0,11.9C0,18.6,5.4,24,12.2,24c5.4,0,10.3-3.6,11.8-8.9C24.1,14.7,24,14.3,23.6,14z M12.2,22C6.6,22,2,17.4,2,11.9c0-4,2.4-7.7,6.1-9.4C8,3,8,3.6,8,4.1c0,6.6,5.4,11.9,12,11.9c0.5,0,1,0,1.6-0.1C19.9,19.6,16.3,22,12.2,22zM23.6,14c-0.2-0.2-0.7-0.3-1-0.2c-0.9,0.2-1.8,0.3-2.7,0.3c-5.5,0-10-4.4-10-9.9c0-0.9,0.1-1.8,0.3-2.6c0.1-0.3,0-0.8-0.3-1.1S9.3-0.1,8.9,0C3.7,1.6,0,6.4,0,11.9C0,18.6,5.4,24,12.2,24c5.4,0,10.3-3.6,11.8-8.9C24.1,14.7,24,14.3,23.6,14z M12.2,22C6.6,22,2,17.4,2,11.9c0-4,2.4-7.7,6.1-9.4C8,3,8,3.6,8,4.1c0,6.6,5.4,11.9,12,11.9c0.5,0,1,0,1.6-0.1C19.9,19.6,16.3,22,12.2,22z",
  },

  phone: {
    id: "phone-icon",
    path:
      "M3.8,0c-0.2,0-0.4,0-0.5,0c-1.8,0.7-2.9,3.3-3.2,5C-0.7,10.8,3.8,15.7,7.9,19c3.7,2.9,10.8,7.6,14.9,3.1 c0.5-0.6,1.2-1.4,1.1-2.2c-0.1-1.4-1.4-2.4-2.4-3.2c-0.8-0.6-2.4-2.1-3.4-2.1c-0.9,0-1.5,1-2,1.5l-1,1c-0.2,0.2-2.3-1.2-2.5-1.4 c-0.9-0.6-1.7-1.2-2.4-1.9s-1.4-1.5-2-2.3c-0.2-0.2-1.5-2.3-1.4-2.4c0,0,1.2-1.3,1.5-1.8c0.7-1.1,1.2-1.9,0.4-3.2 C8.6,3.7,8.2,3.4,7.8,3C7.1,2.3,6.4,1.6,5.6,1.1C5.2,0.7,4.4,0.1,3.8,0z",
  },

  paperScroll: {
    id: "paper-scroll-icon",
    path:
      "M20 2a3 3 0 0 1 3 3v2h-2v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 0 0 .883.993L18 20a1 1 0 0 0 .993-.883L19 19V4H6a1 1 0 0 0-.993.883L5 5v10H3V5a3 3 0 0 1 3-3h14z",
  },

  quotes: {
    id: "quotes-icon",
    path:
      "M10.1,2.6H0.2C0.1,2.6,0,2.7,0,2.8l0,9.8c0,0.1,0.1,0.2,0.2,0.2l4.7,0c0.1,0,0.2,0.1,0.2,0.2v8.1c0,0.1,0.1,0.2,0.2,0.2h3 c0.1,0,0.2-0.1,0.2-0.2l1.7-8.4c0,0,0,0,0,0l0-10C10.3,2.7,10.2,2.6,10.1,2.6z M23.8,2.6h-9.8c-0.1,0-0.2,0.1-0.2,0.2v9.8c0,0.1,0.1,0.2,0.2,0.2l4.7,0c0.1,0,0.2,0.1,0.2,0.2v8.1c0,0.1,0.1,0.2,0.2,0.2 h3c0.1,0,0.2-0.1,0.2-0.2l1.7-8.4c0,0,0,0,0,0l0-10C24,2.7,23.9,2.6,23.8,2.6z",
  },

  star: {
    id: "star-icon",
    path:
      "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z",
  },

  youtube: {
    id: "youtube-icon",
    path:
      "M23,5.3c-0.7-1.2-1.4-1.4-2.8-1.5c-1.4-0.1-5.1-0.1-8.2-0.1c-3.1,0-6.8,0-8.2,0.1C2.4,4,1.7,4.2,1,5.3C0.3,6.5,0,8.5,0,12 c0,0,0,0,0,0c0,0,0,0,0,0v0c0,3.5,0.3,5.5,1,6.6c0.7,1.2,1.4,1.4,2.8,1.5c1.4,0.1,5.1,0.1,8.2,0.1c3.1,0,6.7,0,8.2-0.1 c1.4-0.1,2.1-0.3,2.8-1.5c0.7-1.1,1-3.2,1-6.6c0,0,0,0,0,0c0,0,0,0,0,0C24,8.5,23.7,6.5,23,5.3z M9,16.5v-9l7.5,4.5L9,16.5z",
  },
}

export default paths
